<template>
  <layout-content>
    <template #toolbar>
      <data-time-query :query="query" />

      <site-query :sites="filterSites" :query="query" />

      <factor-tree-query
        ref="factor-tree"
        :factor-tree="factorTree"
        :query="query"
      />

      <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick"
      >查询</el-button>

      <el-button
        :disabled="!tableData.length"
        type="success"
        size="small"
        icon="el-icon-download"
        @click="onDownloadBtnClick"
      >导出</el-button>
    </template>

    <template #body>
      <data-wrapper>
        <z-table
          ref="dataTable"
          :key="dataTableKey"
          :columns="headerColumns"
          :data="tableData"
          :pagination="pagination"
          selected-row-style
          class="legend-table no-wrap-table"
        >
          <template
            v-for="(column, i) in column"
            :slot="`${column.prop}`"
            slot-scope="{row}"
          >
            <span :key="i" :style="`${typeof row[column.prop] === 'boolean' ? (row[column.prop] ? 'color: green;' : 'color: red;') : ''}`">
              {{typeof row[column.prop] === 'boolean' ? (row[column.prop] ? '√' : '×') : (row[column.prop] === '\\' ? '' : row[column.prop])}}
            </span>
          </template>

          <template #z-table-pagination>
          </template>
        </z-table>
        <!-- <data-table
          ref="dataTable"
          :key="dataTableKey"
          :columns="headerColumns"
          :data="tableData"
          :pagination="pagination"
          selected-style
        /> -->
      </data-wrapper>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
// import DataTable from './DataTable'
import ZTable from './ZTable'
import CSVDownloader from '../../../../utils/CSVDownloader'
import DataWrapper from '../../../../components/Data/DataWrapper'
import ZTablePagination from './ZTablePagination'
import ZTableColumn from './ZTableColumn'

export default {
  name: 'VOCsDataCompare',
  routeInfo: {
    label: 'VOCs数据对比',
    icon: 'fa fa-users'
  },
  extends: BaseFactorData,
  components: {DataWrapper, ZTable},
  data () {
    return {
      query: {
        isGetInvalidData: true,
        isFuse: false
      },
      tableData: [],
      normalData: [],
      integralData: [],
      dataTableKey: new Date().getTime(),
      maxHeight: 300,
      rowHeight: 35,
      headerColumns: [],
      column: [],
      ratio: {},
      pagination: new ZTablePagination(1, 100)
    }
  },
  computed: {
    deviceCategories: () => [
      [process.env.ALL_VOCS_DEVICE_CATEGORY],
      1
    ],
    minSiteSelectNumber: () => 1,
    queryTimeStep () {
      let now = new Date()
      let currentMonthDate = now.getDate()
      now.setDate(-1)
      return currentMonthDate + now.getDate()
    },
    formatFactorGroupMap () {
      return this.factorGroups.map(factorGroup => ({
        id: factorGroup.id,
        name: factorGroup.name,
        parentId: factorGroup.parentId
      })).reduce((map, factorGroup) => {
        map[factorGroup.id] = factorGroup
        return map
      }, {})
    },
    filterFactorMap () {
      let {factorMap} = this
      return this.filterSites.reduce((map, site) => site.devices.reduce((map, siteDevice) => siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        let {factorId} = siteDeviceFactor

        if (!map[factorId]) {
          let factor = factorMap[factorId]
          map[factorId] = {
            id: factorId,
            name: factor.name,
            parentId: factor.parentId
          }
        }

        return map
      }, map), map), {})
    },
    filterFactors () {
      return Object.values(this.filterFactorMap)
    },
    factorTree () {
      let { filterFactors } = this
      let factorGroupMap = JSON.parse(
        JSON.stringify(this.formatFactorGroupMap)
      )
      let roots = []

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let { parentId } = factor
        let parent = factorGroupMap[parentId]

        if (parent && parentId !== 'm30000') {
          let { children } = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    }
  },
  methods: {
    onAuditCompletedChanged () {
      let {query} = this
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      if (query.isAuditCompleted === true) {
        query.isGetInvalidData = false
      } else {
        query.isGetInvalidData = true
      }

      this.afterSetSiteIds()
    },
    getData () {
      let {currentQuery} = this
      let query = JSON.parse(JSON.stringify(currentQuery))
      this.changeLoadStatus(true)

      this.$api.Data.getHistoryData({...query, isMultipleIntegral: false}).then(normalData => {
        this.normalData = normalData
        this.$api.Data.getHistoryData({...query, isMultipleIntegral: true}).then(integralData => {
          this.integralData = integralData
          this.formatData()
          this.renderData()
        }).catch(console.error)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData () {
      console.time('data')
      this.getAllData()
      console.timeEnd('data')
    },
    getAllData () {
      this.setTableData()
      this.setTableColumns()
    },
    setTableColumns () {
      let {currentQuery: {siteIds, factorIds, isAuditCompleted}, factorMap, filterSiteMap, ratio} = this
      let headerColumns = []

      let currentQuerySiteMap = siteIds.map(siteId => filterSiteMap[siteId])
      let currentQueryFactorMap = factorIds.map(factorId => factorMap[factorId])

      let column = []

      currentQuerySiteMap.forEach(item => {
        currentQueryFactorMap.forEach(el => {
          let levelHead = [new ZTableColumn({
            prop: `${item.id}_${el.id}OriginalVal`,
            label: isAuditCompleted ? '原始(审核后)' : '原始',
            align: 'center',
            width: 150,
            columns: [new ZTableColumn({
              prop: `${item.id}_${el.id}OriginalVal`,
              label: ratio[`${item.id}_${el.id}OriginalVal`] ? ratio[`${item.id}_${el.id}OriginalVal`] : '',
              align: 'center',
              width: 150,
              fixed: true
            })]
          }), new ZTableColumn({
            prop: `${item.id}_${el.id}IntegralVal`,
            label: '重积分',
            align: 'center',
            width: 150,
            columns: [new ZTableColumn({
              prop: `${item.id}_${el.id}IntegralVal`,
              label: ratio[`${item.id}_${el.id}IntegralVal`] ? ratio[`${item.id}_${el.id}IntegralVal`] : '',
              align: 'center',
              width: 150,
              fixed: true
            })]
          }), new ZTableColumn({
            prop: `${item.id}_${el.id}IsSame`,
            label: '是否相同',
            align: 'center',
            width: 150,
            columns: [new ZTableColumn({
              prop: `${item.id}_${el.id}IsSame`,
              label: ratio[`${item.id}_${el.id}IsSame`] ? '一致率：' + ratio[`${item.id}_${el.id}IsSame`] : '',
              align: 'center',
              width: 150,
              fixed: true
            })]
          })]

          column.push(levelHead.flat())

          headerColumns.push(new ZTableColumn({
            prop: `${item.id}_${el.id}`,
            label: item.name + '_' + el.name,
            align: 'center',
            width: 450,
            columns: levelHead
          }))
        })
      })

      headerColumns.unshift(new ZTableColumn({
        prop: 'dataTime',
        label: '时间',
        align: 'center',
        width: 200,
        fixed: true
      }))
      column.unshift(new ZTableColumn({
        prop: 'dataTime',
        label: '时间',
        align: 'center',
        fixed: true
      }))

      this.column = column.flat()
      this.headerColumns = headerColumns
    },
    setTableData () {
      let {normalData, integralData} = this

      if (!normalData.length) {
        this.tableData = Object.freeze([])
        return
      }

      let {currentQuery: {dataType}} = this

      let beginTime = new Date(normalData[0].dataTime.replace(/-/g, '/'))
      let beginTS = beginTime.getTime()
      let endTime = new Date(normalData[normalData.length - 1].dataTime.replace(/-/g, '/'))
      let endTS = endTime.getTime()
      let tsStep = dataType * 60000
      let dateData = {}

      let defaultObj = {}
      this.currentQuery.siteIds.forEach(site => {
        this.currentQuery.factorIds.forEach(factor => {
          defaultObj[`${site}_${factor}OriginalVal`] = '\\'
          defaultObj[`${site}_${factor}IntegralVal`] = '\\'
          defaultObj[`${site}_${factor}IsSame`] = false
        })
      })

      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        dateData[ts] = {
          dataTime: new Date(ts).format('YYYY-MM-DD HH:mm:ss'),
          ...defaultObj
        }
      }
      let flag = false

      normalData.forEach(data => {
        let {siteId, factorId, value, dataTime} = data
        let ts = new Date(dataTime.replace(/-/g, '/')).getTime()

        let tsData = dateData[ts]

        if (!tsData) {
          return
        }

        tsData.siteId = siteId
        tsData[`${siteId}_${factorId}OriginalVal`] = value
        tsData[`${siteId}_${factorId}IntegralVal`] = '--'
        tsData[`${siteId}_${factorId}IsSame`] = flag
      })

      if (!integralData.length) {
        this.computedRatio(Object.values(dateData))
        this.tableData = Object.freeze(Object.values(dateData))
        return
      }

      integralData.forEach(data => {
        let {dataTime, factorId, siteId, isHaveIntegral, value} = data
        let ts = new Date(dataTime).getTime()

        if (dateData[ts] && dateData[ts].siteId === siteId && isHaveIntegral) {
          dateData[ts][siteId + '_' + factorId + 'IntegralVal'] = value
          dateData[ts][siteId + '_' + factorId + 'IsSame'] = value === dateData[ts][siteId + '_' + factorId + 'OriginalVal']
        }
      })

      this.computedRatio(Object.values(dateData))
      this.tableData = Object.freeze(Object.values(dateData))
    },
    computedRatio (data) {
      let ratio = JSON.parse(JSON.stringify(data[0]))
      ratio.dataTime = '一致率'

      for (let item in ratio) {
        ratio[item] = ''

        if (item.search('IsSame') !== -1) {
          let denominator = data.filter(el => el.hasOwnProperty(item))
          let flagTrue = data.filter(el => el[item] === true)

          ratio[item] = Number((flagTrue.length / denominator.length * 100).toFixed(2)) + '%'
        }
      }

      this.ratio = ratio
    },
    getSummaries (param) {
      const { columns, data } = param
      const ratio = []

      columns.forEach((column, index) => {
        if (index === 0) {
          ratio[index] = '一致率'
          return
        }

        if (column.label === '是否相同') {
          const values = data.map(item => Number(item[column.property]))
          let flagTrue = values.filter(el => el[column.property] === true)
          ratio[index] = flagTrue.length / values.length * 100 + '%'
        }
      })

      return ratio
    },
    onDownloadBtnClick () {
      let {headerColumns, currentQuery: {beginTime, endTime, isAuditCompleted}, tableData} = this
      let csvData = tableData.map(el => {
        delete el.siteId
        return {...el}
      })

      let csvName = `${new Date(beginTime).format('YYYY年MM月DD日')}_${new Date(endTime).format('YYYY年MM月DD日')}VoCs数据对比`
      let data = csvData.map(el => {
        return [...Object.values(el)].map(item => typeof item === 'boolean' ? (item ? '是' : '否') : (item === '\\' ? '' : item))
      })
      let firstColumn = ['']
      let secondColumn = ['']
      let thirdColumn = ['时间']

      headerColumns.forEach(el => {
        if (el.label !== '时间') {
          firstColumn.push('')
          firstColumn.push(el.label)
          firstColumn.push('')
          secondColumn.push(isAuditCompleted ? '原始(审核后)' : '原始')
          secondColumn.push('重积分')
          secondColumn.push('是否相同')

          el.leafColumns.forEach(second => {
            thirdColumn.push(second.leafColumns[0].label)
          })
        }
      })

      CSVDownloader([firstColumn, secondColumn, thirdColumn, ...data], csvName)
    }
  }
}
</script>

<style lang="scss" scoped>
.no-wrap-table {
  --z-table-white-space: nowrap;
}
legend {
  font-size: 16px;
  padding: 0 1em;
  color: #303133;
  text-align: center;
}
.z-table {
  min-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/08VOCs-Data-Compare/index.vue